import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import moment from 'moment'
import { useEffect, useState } from 'react'
import audienceApi from 'services/api/audience'
import { formatPrice } from 'utils/common'

import { ReactComponent as AudienceIcon } from './audience.svg'
import styles from './CampaignStartConfirmation.module.scss'
import { ReactComponent as CostIcon } from './cost.svg'

const CampaignStartConfirmation = ({
  deliveryName,
  handleConfirm,
  handleCancel,
  audienceId,
  startDate
}) => {
  const [audienceSize, setAudienceSize] = useState(0)
  const [audienceName, setAudienceName] = useState('')
  const [isLoading, setisLoading] = useState(true)

  const SMS_COST = 0.03

  useEffect(() => {
    setisLoading(true)
    audienceApi.get(audienceId).then(data => {
      setAudienceSize(data.size)
      setAudienceName(data.name)
      setisLoading(false)
    })
  }, [audienceId])

  if (isLoading) return <LoadingIndicator />

  return (
    <ConfirmationDialog
      title={`Start ${deliveryName}`}
      onConfirm={handleConfirm}
      onClose={handleCancel}
      negativeMessage="Cancel"
      positiveMessage="Yes, start"
      contentPadding={0}
    >
      <div className={styles.table}>
        <div className={styles.row}>
          <AudienceIcon />
          <strong>{audienceSize} guests</strong>
          <span className={styles.extra}>{audienceName}</span>
        </div>
        <div className={styles.row}>
          <CostIcon />
          <strong>{formatPrice(SMS_COST * audienceSize)} approx.</strong>
          <span className={styles.extra}>${SMS_COST}/sms *</span>
        </div>
        <hr />
        <div className={styles.footnote}>
          * Every month, first 500 messages are free of charge
        </div>
        <div className={styles.footnote}>
          Guests who live in states having travel restrictions will not receive this
          message and you won't be charged for those messages
        </div>
      </div>
      <div className={styles.content}>
        <p>
          This campaign will start sending messages on{' '}
          {moment(startDate).format('MMM DD, YYYY')} to "{audienceName}" audience. Do you
          want to start the campaign?
        </p>
      </div>
    </ConfirmationDialog>
  )
}

export default CampaignStartConfirmation
